import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import LinkButton from 'flarum/common/components/LinkButton';
import classList from 'flarum/common/utils/classList';
import sortTags from 'flarum/tags/common/utils/sortTags';

export default class NavigationBar extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.tagItem = [];
    this.localeMainImgUrl = '';
    app.tagList
      .load([
        'children',
        'lastPostedDiscussion',
        'parent',
        'wikiLabel',
        'wikiLabel.wikiLabelOptions',
        'wikiLabel.wikiLabelOptions.wikiLabelOptionsSon',
        'wikiHeroDetailDiscussion',
        'heroTagLatestdata',
        'heroTagLatestdata.heroTagHeroIntro',
        'heroTagLatestdata.heroTagHeroIntro.heroTagHeroLevel',
      ])
      .then(() => {
        this.tags = sortTags(app.store.all('tags').filter((tag) => !tag.isChild() && tag.pkgId() == app.data.pkgLogo.id));
        this.loading = false;
        m.redraw();
      });
    this.bodyClass = 'App--page';
    this.loading = true;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.setupWheelScrolling();
  }

  onremove(vnode) {
    super.onremove(vnode);
    this.cleanupWheelScrolling();
  }
  view(vnode) {
    return (
      <div className="sideNavContainer NavigationBar-container">
        <nav className="IndexPage-nav sideNav navItems navItems-lin">
          <ul id="navItems-ul">{listItems(this.navItems(vnode).toArray())}</ul>
        </nav>
      </div>
    );
  }

  navItems(vnode) {
    const items = new ItemList();
    const params = app.search.stickyParams();
    // this.activeButton = localStorage.getItem('activeButton') || 'allDiscussions';
    items.add(
      'allDiscussions',
      <LinkButton
        href={app.route('pages.home', params)}
        onclick={(e) => {
          const active = document.getElementsByClassName('item-allDiscussions')[0].classList.value.indexOf('active');
          if (active !== -1) {
            e.preventDefault(); // 阻止跳转
            return false; // 防止进一步处理
          }
        }}
      >
        <span className={classList(['navItem', vnode.attrs.routeName == 'pages.home' ? 'underline-yellow' : ''])}>
          {app.translator.trans('dl-index.forum.indexPage')}
        </span>
      </LinkButton>,
      100
    );

    // items.add(
    //   'plate',
    //   <LinkButton href={app.route('tags')}>
    //     <span className={classList(["navItem plate",
    //       vnode.attrs.routeName == 'tags' ? 'underline-yellow' : ''
    //     ])}>{app.translator.trans('dl_tag.forum.title')}</span>
    //   </LinkButton>,
    //   70
    // );
    if (!this.loading) {
      const pinned = this.tags.filter((tag) => {
        if (app.session.user) {
          return (
            tag.position() !== null &&
            tag.pkgId() == app.data.pkgLogo.id &&
            ((app.session.user.isAdmin() && (tag.isAdminLook() || !tag.isHidden())) || (!app.session.user.isAdmin() && !tag.isHidden()))
          );
        } else {
          return tag.position() !== null && tag.pkgId() == app.data.pkgLogo.id && !tag.isHidden();
        }
      });
      if (pinned && pinned.length > 0) {
        pinned
          .sort((a, b) => {
            return a.sortCount() - b.sortCount();
          })
          .forEach((element) => {
            let name = element.name();
            // 将字符串映射转换为 JavaScript 对象
            const obj = JSON.parse(name);
            // 创建 Map 对象并初始化
            const map = new Map(Object.entries(obj));
            // 获取特定键的值
            let localeName = map.get(app.data.locale);
            items.add(
              'tagItem' + element.id(),
              <LinkButton
                href={app.route('tag', { tags: element.slug() })}
                onclick={(e) => {
                  const active = document.getElementsByClassName(`item-tagItem${element.id()}`)[0].classList.value.indexOf('active');
                  if (active !== -1) {
                    e.preventDefault(); // 阻止跳转
                    return false; // 防止进一步处理
                  }
                }}
              >
                <span className={classList(['navItem plate', vnode.attrs.routeName == 'tag' ? 'underline-yellow' : ''])}>{localeName}</span>
              </LinkButton>,
              70
            );
          });
      }
    }

    return items;
  }
  setupWheelScrolling() {
    const scrollContainer = this.element.querySelector('#navItems-ul');
    if (!scrollContainer || this.currentWheelHandler) return;

    const wheelHandler = (event) => {
      // Keep native horizontal gestures, zooming, and page scrolling when the menu fits.
      if (event.ctrlKey || event.shiftKey || event.deltaX || scrollContainer.scrollWidth <= scrollContainer.clientWidth) return;

      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? scrollContainer.clientWidth : 1;
      const delta = event.deltaY * unit;
      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      if ((delta > 0 && scrollContainer.scrollLeft < maxScroll) || (delta < 0 && scrollContainer.scrollLeft > 0)) {
        event.preventDefault();
        scrollContainer.scrollLeft += delta;
      }
    };

    scrollContainer.addEventListener('wheel', wheelHandler, { passive: false });
    this.scrollContainer = scrollContainer;
    this.currentWheelHandler = wheelHandler;
  }
  cleanupWheelScrolling() {
    if (this.scrollContainer && this.currentWheelHandler) {
      this.scrollContainer.removeEventListener('wheel', this.currentWheelHandler);
    }
    this.scrollContainer = null;
    this.currentWheelHandler = null;
  }
}
